import React, { useCallback, useEffect, useMemo } from 'react';
import { Box } from '@mui/material';
import { useAPIClientRequest } from 'c-hooks';
import apiClient from 'c-data/apiClient';
import to from 'await-to-js';
import type { PopDisplays_LogFileImportSummary } from 'c-sdk';
import LogFileImportSummaryTable from './LogFileImportSummaryTable';

type Props = {
    logFileImportId: number;
};

const LogFileImportDetails: React.FC<Props> = ({ logFileImportId }) => {
    const { start, data, reset, isLoading } = useAPIClientRequest(
        apiClient.Entities.PopDisplays_LogFileImportSummary.summary,
    );
    const loadData = useCallback(async () => {
        await to(start(logFileImportId));
    }, [start, logFileImportId]);

    const resources = useMemo<PopDisplays_LogFileImportSummary[]>(() => {
        const body = (data as any)?.data;
        const list = Array.isArray(body) ? body : body?.data;
        return Array.isArray(list) ? list : [];
    }, [data]);

    useEffect(() => {
        loadData();

        return () => {
            reset();
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box display="flex" flex={1} flexDirection="column" py={2}>
            <Box flex={1} display="flex" flexDirection="column" overflow="hidden">
                <Box display="flex" overflow="hidden" flexDirection="column" flex={1}>
                    <LogFileImportSummaryTable resources={resources} loading={isLoading} />
                </Box>
            </Box>
        </Box>
    );
};

export default LogFileImportDetails;
